// src/App.tsx
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import SchemaTree from './components/SchemaTree';
import SchemaEditor from './components/SchemaEditor';
import './styles/App.css';

export interface SchemaNode {
  title: string;
  schemaId?: string;
  children?: SchemaNode[];
}

const App: React.FC = () => {
  const [selectedSchema, setSelectedSchema] = useState<SchemaNode | null>(null);
  // schemaContent is:
  // - undefined when no schema is selected,
  // - null when a schema is selected but still loading,
  // - an object when the schema has loaded.
  const [schemaContent, setSchemaContent] = useState<any | undefined>(undefined);

  useEffect(() => {
    console.log("Selected schema changed:", selectedSchema);
    if (selectedSchema && selectedSchema.schemaId) {
      // Set to null to indicate that we're loading the full schema.
      setSchemaContent(null);
      const fetchSchema = async () => {
        try {
          console.log("Fetching schema from:", selectedSchema.schemaId);
          const res = await fetch(selectedSchema.schemaId!);
          console.log("Fetch response status:", res.status);
          if (!res.ok) {
            const errorText = await res.text();
            throw new Error(`Error fetching schema content (status ${res.status}): ${errorText}`);
          }
          const data = await res.json();
          console.log("Fetched schema data:", data);
          setSchemaContent(data);
        } catch (error) {
          console.error("Error fetching schema content:", error);
          // Optionally, set to an empty object or leave as null to indicate failure.
          setSchemaContent({});
        }
      };
      fetchSchema();
    } else {
      console.log("No schema selected or schemaId undefined.");
      setSchemaContent(undefined);
    }
  }, [selectedSchema]);

  return (
    <Router>
      <Navbar />
      <div className="main-container">
        {/* Sidebar Tree remains unchanged */}
        <SchemaTree onSelect={setSelectedSchema} />
        {/* Editor Container: SchemaEditor receives the full JSON schema */}
        <div className="editor-container">
          <Routes>
            <Route path="/" element={<SchemaEditor schema={schemaContent} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
